// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--2-1!../../assets/bootstrap.min.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--2-1!../../assets/fonts/stylesheet.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--2-1!assets/about-us.css");
var ___CSS_LOADER_AT_RULE_IMPORT_3___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--2-1!assets/services.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
exports.push([module.id, "html,body{height:100%}body{font-family:\"Roboto\",sans-serif}h1,h2,h3,h4,h5,h6{font-family:'Sarabun', sans-serif}a{cursor:pointer}a:hover{text-decoration:none;color:#2792e6}a:active{text-decoration:none;color:#2792e6}a:focus{text-decoration:none;color:#2792e6}@media print{.no-print,.no-print *{display:none !important}}\n", ""]);
// Exports
module.exports = exports;
